import { Button, DatePicker, Form, Modal, Select } from "antd";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import axiosInstance from "../common/api";
import { filterOption } from "../common/common";
import { useNavigate } from "react-router-dom";

export default function NewAttendanceRawRecord({}) {
    const [form] = Form.useForm();
    const [employees, setEmployees] = useState([]);
    const navigate = useNavigate();
    const timestamp = Form.useWatch("timestamp", form);

    useEffect(() => {
        document.body.style.overflow = "inherit";
        if (!!timestamp) {
            const dateStr = timestamp.format("YYYY-MM-DD");
            axiosInstance
                .get("employeeCompact", { params: { startDate: dateStr, endDate: dateStr } })
                .then(({ data }) => setEmployees(data));
        }
    }, [timestamp]);

    const onFormFinish = (form) => {
        const data = {
            employee: form.employee,
            timestamp: dayjs.utc(form.timestamp.tz(dayjs.tz.guess())).format(),
            src: "web",
        };
        axiosInstance.post("attendanceRawRecord", [data])
        .then(() => navigate(-1))
    };

    return (
        <Form id="newAttendanceRawRecordForm" form={form} layout="vertical" onFinish={onFormFinish}>
            <Form.Item name={"timestamp"} label="Data e ora">
                <DatePicker format="DD/MM/YYYY HH:mm" showTime />
            </Form.Item>
            <Form.Item name={"employee"} label="Dipendente">
                <Select
                    disabled={!timestamp}
                    options={employees.map((x) => ({ value: x.id, label: x.fullName }))}
                    showSearch
                    filterOption={filterOption}
                />
            </Form.Item>
            <Form.Item>
                <Button htmlType="submit" type="primary">
                    Conferma
                </Button>
            </Form.Item>
        </Form>
    );
}
